import {
  ChangeDetectorRef,
  Component
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import {
  SkyDropdownMessage,
  SkyDropdownMessageType,
  SkyDropdownMenuChange
} from '../../core';


export class SkyDropdownDemoComponent {
  public dropdownController = new Subject<SkyDropdownMessage>();
  public items: any[] = [
    { name: 'Option 1', disabled: false },
    { name: 'Option 2', disabled: true },
    { name: 'Option 3', disabled: false },
    { name: 'Option 4', disabled: false },
    { name: 'Option 5', disabled: false }
  ];

  constructor(
    private changeDetector: ChangeDetectorRef
  ) { }

  public optionClicked(option: number) {
    alert('You selected option ' + option);
  }

  public openDropdown() {
    this.sendMessage(SkyDropdownMessageType.Open);
  }

  public closeDropdown() {
    this.sendMessage(SkyDropdownMessageType.Close);
  }

  public focusTriggerButton() {
    this.sendMessage(SkyDropdownMessageType.FocusTriggerButton);
  }

  public focusNextItem() {
    this.sendMessage(SkyDropdownMessageType.FocusNextItem);
  }

  public focusPreviousItem() {
    this.sendMessage(SkyDropdownMessageType.FocusPreviousItem);
  }

  public changeItems() {
    this.items.pop();
    this.changeDetector.detectChanges();
  }

  public onMenuChanges(change: SkyDropdownMenuChange) {
    if (change.activeIndex !== undefined) {
      console.log('The menu\'s active index changed to:', change.activeIndex);
    }
  }

  private sendMessage(type: SkyDropdownMessageType) {
    const message: SkyDropdownMessage = { type };
    this.dropdownController.next(message);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-dropdown-demo',
  template: `
<h3>
  Button types and styles
</h3>

<sky-row>
  <sky-column screenSmall="6">
    <ul class="sky-list-unstyled">
      <li>
        Default (select) style:
        <br>
        <sky-dropdown>
          <sky-dropdown-button>
            Show dropdown
          </sky-dropdown-button>
          <sky-dropdown-menu>
            <sky-dropdown-item *ngFor="let item of items">
              <button type="button" [attr.disabled]="item.disabled ? '' : null">
                {{ item.name }}
              </button>
            </sky-dropdown-item>
          </sky-dropdown-menu>
        </sky-dropdown>
      </li>
      <li>
        Context menu style:
        <br>
        <sky-dropdown
          buttonType="context-menu">
          <sky-dropdown-menu>
            <sky-dropdown-item *ngFor="let item of items">
              <button type="button" [attr.disabled]="item.disabled ? '' : null">
                {{ item.name }}
              </button>
            </sky-dropdown-item>
          </sky-dropdown-menu>
        </sky-dropdown>
      </li>
      <li>
        Icon style:
        <br>
        <sky-dropdown
          buttonType="folder-open-o">
          <sky-dropdown-menu>
            <sky-dropdown-item *ngFor="let item of items">
              <button type="button" [attr.disabled]="item.disabled ? '' : null">
                {{ item.name }}
              </button>
            </sky-dropdown-item>
          </sky-dropdown-menu>
        </sky-dropdown>
      </li>
    </ul>
  </sky-column>
  <sky-column screenSmall="6">
    <ul class="sky-list-unstyled" style="text-align:right">
      <li>
        Select primary style:
        <br>
        <sky-dropdown
          alignment="right"
          buttonStyle="primary">
          <sky-dropdown-button>
            Show dropdown
          </sky-dropdown-button>
          <sky-dropdown-menu>
            <sky-dropdown-item *ngFor="let item of items">
              <button type="button" [attr.disabled]="item.disabled ? '' : null">
                {{ item.name }}
              </button>
            </sky-dropdown-item>
          </sky-dropdown-menu>
        </sky-dropdown>
      </li>
      <li>
        Context menu with primary style:
        <br>
        <sky-dropdown
          alignment="right"
          buttonType="context-menu"
          buttonStyle="primary">
          <sky-dropdown-menu>
            <sky-dropdown-item *ngFor="let item of items">
              <button type="button" [attr.disabled]="item.disabled ? '' : null">
                {{ item.name }}
              </button>
            </sky-dropdown-item>
          </sky-dropdown-menu>
        </sky-dropdown>
      </li>
      <li>
        Icon with primary style:
        <br>
        <sky-dropdown
          alignment="right"
          buttonType="folder-open-o"
          buttonStyle="primary">
          <sky-dropdown-menu>
            <sky-dropdown-item *ngFor="let item of items">
              <button type="button" [attr.disabled]="item.disabled ? '' : null">
                {{ item.name }}
              </button>
            </sky-dropdown-item>
          </sky-dropdown-menu>
        </sky-dropdown>
      </li>
    </ul>
  </sky-column>
</sky-row>

<h3>
  Interacting with a dropdown programmatically
</h3>

<p>
  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="openDropdown()">
    Open dropdown
  </button>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="closeDropdown()">
    Close dropdown
  </button>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="focusTriggerButton()">
    Focus trigger button
  </button>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="focusNextItem()">
    Focus next item
  </button>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="focusPreviousItem()">
    Focus previous item
  </button>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="changeItems()">
    Change items
  </button>
</p>
<sky-dropdown
  buttonStyle="primary"
  [dismissOnBlur]="false"
  [messageStream]="dropdownController">
  <sky-dropdown-button>
    Open
  </sky-dropdown-button>
  <sky-dropdown-menu
    [useNativeFocus]="false"
    (menuChanges)="onMenuChanges($event)">
    <sky-dropdown-item *ngFor="let item of items">
      <button type="button" [attr.disabled]="item.disabled ? '' : null">
        {{ item.name }}
      </button>
    </sky-dropdown-item>
  </sky-dropdown-menu>
</sky-dropdown>
<p>
  This menu does not bring the active items to focus; this is useful for custom implementations where the focus should remain on a different control.
</p>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
